import { TestCaseSearchResult } from "../../../../../../api/models/test-series/TestCaseSearchResult";
import { HeaderType } from "../components/TestCasesParametersTable/TestCasesParametersTable";
import { SortableColumn } from "../interfaces/RowData";

export default function generateHeaderRow(testCases: TestCaseSearchResult[]): HeaderType<SortableColumn>[] {
  const headerArray: HeaderType<SortableColumn>[] = [];
  headerArray.push({ id: "id", name: "ID", filterableColumnId: "id" });
  if (testCases[0]?.secondSubstrateActionFlowName) {
    headerArray.push({
      id: "firstSubstrate",
      name: "Substrate 1",
      tooltip: {
        section: "substrate",
        chipSelector: "firstSubstrateSecondaryChips",
      },
      filterableColumnId: "firstSubstrate",
    });
    headerArray.push({
      id: "secondSubstrate",
      name: "Substrate 2",
      tooltip: {
        section: "substrate",
        chipSelector: "secondSubstrateSecondaryChips",
      },
      filterableColumnId: "secondSubstrate",
    });
  }
  if (testCases[0]?.firstSubstrateActionFlowName && !testCases[0]?.secondSubstrateActionFlowName) {
    headerArray.push({
      id: "firstSubstrate",
      name: "Substrate",
      tooltip: {
        section: "substrate",
        chipSelector: "firstSubstrateSecondaryChips",
      },
      filterableColumnId: "firstSubstrate",
    });
  }
  headerArray.push({
    id: "product",
    name: "Product",
    tooltip: {
      section: "material",
      subHeader: "productSubHeader",
      chipSelector: "productSampleSecondaryChips",
    },
    filterableColumnId: "product",
  });
  if (!testCases[0]?.hasOnlyGlobalBuildingActions) {
    headerArray.push({
      id: "buildingAction",
      name: "Building Action",
      tooltip: {
        section: "testpiece",
        chipSelector: "buildingActionSecondaryChips",
      },
      filterableColumnId: "buildingAction",
    });
  }
  if (!testCases[0]?.hasOnlyGlobalTreatments) {
    headerArray.push({
      id: "treatment",
      name: "Specimen Treatment",
      tooltip: {
        section: "testpiece",
        chipSelector: "specimenTreatmentSecondaryChips",
      },
      filterableColumnId: "treatment",
    });
  }
  if (!testCases[0]?.hasOnlyGlobalConditions) {
    headerArray.push({
      id: "condition",
      name: "Test Condition",
      tooltip: {
        section: "condition",
        chipSelector: "conditionSecondaryChips",
      },
      filterableColumnId: "condition",
    });
  }
  return headerArray;
}
